import mqtt from 'mqtt';
import { wrap } from 'mqtt-sub-router';
import { RESET_SUBSCRIBE_TO_ORGANIZATION, SUBSCRIBE_TO_ORGANIZATION } from '../actions/types';
import AccountCreateConfirmationRouter from '../routers/AccountCreateConfirmationRouter';
import AccountCreateRouter from '../routers/AccountCreateRouter';
import AccountRouter from '../routers/AccountRouter';
import DevicesRouter from '../routers/DevicesRouter';
import OrganizationRouter from '../routers/OrganizationRouter';
import setPasswordRouter from '../routers/setPasswordRouter';
import { store } from '../store/store';
import { b64DecodeUnicode, b64EncodeUnicode } from '../utils/encoding';
import { defaultMiddlewares } from './middleware';

let mqttConfig = {};

export const subscribedDevices = {};

export const fetchConfig = callback => {
	fetch('/conf/mqttConfig.json').then(response => {
		response.json().then(data => {
			mqttConfig = data[`mqttConfig${process.env.REACT_APP_FM || ''}`];
			callback();
			store.dispatch({
				type: 'MQTT_CONFIG',
				payload: mqttConfig,
			});
		});
	});
};

export function RecreateMqttClient() {
	let user = localStorage.getItem('email');
	let psw = localStorage.getItem('psw');

	if (user !== null && psw !== null && window.location.pathname !== '/') {
		// Reauthenticate
		checkLogin(b64DecodeUnicode(user), b64DecodeUnicode(psw), response => {
			store.dispatch({
				type: 'SET_MQTTCLIENT',
				payload: {
					client: response.client,
				},
			});
		});
	}
}

export function subscribe(client, userName) {
	client.listen(`${b64EncodeUnicode(userName)}/#`, AccountRouter);
}

export function subscribeToAccountCreate(client) {
	const publishTopic = 'microservice/public/accountCreate';
	const subscribeTopic = `${b64EncodeUnicode('anonymous')}/#`;

	client.listen(subscribeTopic, AccountCreateRouter);

	const unsubscribeCallback = () => client.unlisten(subscribeTopic);

	return { publishTopic, subscribeTopic, unsubscribeCallback };
}

export function subscribeToAccountCreateConfirmation(client, userName) {
	const publishTopic = 'microservice/public/accountCreateConfirmation';
	const subscribeTopic = `${b64EncodeUnicode(userName)}/#`;

	client.listen(subscribeTopic, AccountCreateConfirmationRouter);

	const unsubscribeCallback = () => client.unlisten(subscribeTopic);

	return { publishTopic, subscribeTopic, unsubscribeCallback };
}

export function subscribeToOrganization(client, organizationId) {
	client.listen(`${organizationId}/events/#`, OrganizationRouter);
	store.dispatch({
		type: SUBSCRIBE_TO_ORGANIZATION,
		payload: {
			orgId: organizationId,
		},
	});
}

export function subscribeToDevice(client, serialNumber) {
	client.listen(`${serialNumber}/status/#`, DevicesRouter, {
		rh: 1,
	});
}

export function unsubscribeToAll(client, userName) {
	client.unlisten(`${b64EncodeUnicode(userName)}/#`);
}

export function confirmInvite(client, token, password) {
	client.publish(`microservice/account_confirmation`, {
		requestId: 'deleteUserRequestId',
		data: {
			token: token,
			password: password,
		},
	});
}

function getAccountInfo(mqttClient, userName) {
	mqttClient.publish(
		`microservice/${b64EncodeUnicode(userName)}/getOwnAccountInfo`,
		JSON.stringify({ requestId: 'someId' })
	);
}

export async function checkLogin(userName, password, callback) {
	fetchConfig(() => {
		let client = mqtt.connect(
			`${mqttConfig.protocol}://${mqttConfig.host}:${mqttConfig.port}/${mqttConfig.path}`,
			{
				username: userName.toLowerCase(),
				password: password,
				protocolVersion: mqttConfig.protocolVersion,
				keepalive: mqttConfig.keepalive,
				reconnectPeriod: mqttConfig.reconnectPeriod,
			}
		);

		// wrap client
		client = wrap(client, defaultMiddlewares);
		subscribe(client, userName.toLowerCase());

		store.dispatch({
			type: RESET_SUBSCRIBE_TO_ORGANIZATION,
			payload: {},
		});
		client.mqttClient.on('connect', event => {
			console.log(Date(new Date().getTime()));
			console.debug(`Client ${mqttConfig.clientID} has been CONNECTED to broker`);
			window.client = client.mqttClient;
			window.onbeforeunload = function(event) {
				this.localStorage.setItem('lastVisit', new Date().getTime());
				return;
			};

			localStorage.setItem('email', b64EncodeUnicode(userName.toLowerCase()));
			localStorage.setItem('psw', b64EncodeUnicode(password));

			getAccountInfo(client.mqttClient, userName.toLowerCase());

			callback({
				client,
				connected: true,
			});
		});

		client.mqttClient.on('reconnect', event => {
			console.debug('reconnect event: ', event);
		});

		client.mqttClient.on('close', event => {
			console.debug('close event: ', event, client);
			window.dispatchEvent(
				new CustomEvent('stayLoginSession', {
					detail: {
						client: client,
						userName: userName,
						clientId: mqttConfig.clientID,
					},
				})
			);
		});

		client.mqttClient.on('error', error => {
			console.debug(`Client ${mqttConfig.clientID}: Error in connection to broker`);
			console.debug(error);
			if (error && error.code === 134) {
				client.mqttClient.end(true, {});
			}
			store.dispatch({
				type: 'SET_MQTTCLIENT',
				payload: {
					client,
				},
			});
			callback({
				connected: false,
				error:
					error
						.toString()
						.split('Connection refused:')
						.pop() || 'Error',
			});
		});

		client.mqttClient.on('disconnect', event => {
			console.debug('disconnect event: ', event);
			/* window.dispatchEvent(
				new CustomEvent('stayLoginSession', {
					detail: {
						client: client,
						userName: userName,
						clientId: mqttConfig.clientID,
					},
				})
			); */

			return;
		});
		client.mqttClient.on('end', event => {
			console.debug('end event: ', event);
			return;
		});
	});
}

export async function automaticLogin(username, password, callback) {
	fetchConfig(() => {
		let client = mqtt.connect(
			`${mqttConfig.protocol}://${mqttConfig.host}:${mqttConfig.port}/${mqttConfig.path}`,
			{
				username: username,
				password: password,
				protocolVersion: mqttConfig.protocolVersion,
				keepalive: mqttConfig.keepalive,
			}
		);

		// wrap client
		client = wrap(client, defaultMiddlewares);
		subscribe(client, username);
		client.listen(`${b64EncodeUnicode(username)}/#`, setPasswordRouter);

		client.mqttClient.on('connect', event => {
			console.log(Date(new Date().getTime()));
			console.debug(`Client ${mqttConfig.clientID} has been CONNECTED to broker`);
			window.client = client.mqttClient;
			window.onbeforeunload = function(event) {
				this.localStorage.setItem('lastVisit', new Date().getTime());
				return;
			};

			callback({
				client,
				connected: true,
			});
		});

		client.mqttClient.on('error', error => {
			console.error(`Client ${mqttConfig.clientID}: Error in connection to broker`);
			if (error && error.code === 134) {
				client.mqttClient.end(true, {});
			}
			store.dispatch({
				type: 'SET_MQTTCLIENT',
				payload: {
					client,
				},
			});
			callback({
				connected: false,
				error:
					error
						.toString()
						.split('Connection refused:')
						.pop() || 'Error',
			});
		});

		client.mqttClient.on('disconnect', event => {
			console.log(event);
			store.dispatch({
				type: 'SET_MQTTCLIENT',
				payload: {
					client,
				},
			});
			console.debug(`Client ${mqttConfig.clientID} has been DISCONNECTED from broker`);
			callback({
				client,
				connected: false,
			});
		});
	});
}

export function anonymous(callback) {
	fetchConfig(() => {
		let client = mqtt.connect(
			`${mqttConfig.protocol}://${mqttConfig.host}:${mqttConfig.port}/${mqttConfig.path}`,
			{
				username: 'anonymous',
				password: 'password',
				protocolVersion: mqttConfig.protocolVersion,
				keepalive: mqttConfig.keepalive,
			}
		);

		client.on('connect', event => {
			client = wrap(client, defaultMiddlewares);
			client.listen(`${b64EncodeUnicode('anonymous')}/#`, setPasswordRouter);
			callback(client);
		});
	});
}
export async function signOut(client) {
	if (localStorage.getItem('email') && localStorage.getItem('psw')) {
		await client.mqttClient.publish(
			`microservice/${localStorage.getItem('email')}/signOut`,
			JSON.stringify({
				requestId: 'signOutRequestId',
				data: {
					username: b64DecodeUnicode(localStorage.getItem('email')),
				},
			}),
			{ qos: 2 },
			() => {
				console.log('client end callback');
				client.mqttClient.end(true);
			}
		);
	} else {
		client.mqttClient.end(true);
	}
}
